<template>
	<div class="inline-date-calendar-vuepic">
		<VueDatePicker
			:model-value="modelValue"
			:locale="$i18n.locale"
			:min-date="minDate"
			:max-date="maxDate"
			:enable-time-picker="withTime"
			:inline="true"
			:teleport="false"
			:auto-apply="!withTime"
			v-bind="options"
			@update:model-value="onPick"
		/>
	</div>
</template>

<script setup lang="ts">
import '@vuepic/vue-datepicker/dist/main.css'

/**
 * Calendar for InlineDateEditor on top of VueDatePicker. The only file that knows about
 * this library, and the whole contract with the editor is the props and the events
 * below. Another calendar, our own or a third party one, is plugged in by a file with
 * the same contract and nothing else changes.
 */
withDefaults(defineProps<{
	modelValue: Date | null,
	minDate?: Date,
	maxDate?: Date,
	withTime?: boolean,
	options?: Record<string, unknown>,
}>(), {
	minDate: undefined,
	maxDate: undefined,
	withTime: false,
	options: () => ({}),
})

const emit = defineEmits<{
	(e: 'select', value: Date | null): void,
	(e: 'close'): void,
}>()

const onPick = (value: Date | null) => {
	emit('select', value)
	emit('close')
}
</script>

<style scoped lang="scss">
.inline-date-calendar-vuepic {
	padding: 4px;

	:deep(.dp__input_wrap) {
		display: none;
	}

	:deep(.dp__menu) {
		border: none;
		box-shadow: none;
	}
}
</style>
